module.exports = __webpack_public_path__ + "img/zone200250.b170a563.png";